import { ChevronDownIcon, ChevronUpIcon } from "@100mslive/react-icons";
import {
    Avatar,
    Box,
    Button,
    ClickAwayListener,
    Grow,
    InputAdornment,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    TextField,
} from "@material-ui/core";
import { AddCircleRounded } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { useGoogleLogout } from "react-google-login";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import logo from "../../assets/images/Logo.svg";
import { socket } from "../../helpers/socketHelper";
import { clearToken } from "../../helpers/utility";
import PIPComponent from "../../pages/Marketplace/Livestream/PIPComponent";
import { NotificationComponent } from "../../pages/Notification/Notification";
import { fetchNotificationRequest } from "../../store/notification/notification.actions";
import NotificationAPI from "../../store/notification/notification.api";
import { getNotificationList } from "../../store/notification/notification.selector";
import {
    addCartRequest,
    getProductsRequest,
} from "../../store/shopping/shopping.actions";
import { getProductsList } from "../../store/shopping/shopping.selector";
import {
    fetchLiveStreamByIdRequest,
    getJustStreamRequest,
    getRecentStreamRequest,
} from "../../store/social/social.actions";
import SocialAPI from "../../store/social/social.api";
import {
    getFollowingStreams,
    getRecentLiveStreams,
} from "../../store/social/social.selector";
import { getDeliveryAddressRequest } from "../../store/user/deliveryaddress/deliveryaddress.actions";
import {
    fetchOtherUserProfileRequest,
    followUserRequest,
    searchUserRequest,
} from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import NotificationsModal from "../Modal/NotificationsModal";

const routes = [
    // {
    //     id: 0,
    //     name: "chat",
    //     path: "/page/chat",
    //     icon: (
    //         <svg
    //             width="26"
    //             height="26"
    //             className="stroke-current"
    //             viewBox="0 0 18 18"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //         >
    //             <path
    //                 d="M5.25 5.875H12.75M5.25 8.375H9M0.875 9.63334C0.875 10.9667 1.81083 12.1283 3.13083 12.3225C4.07167 12.4608 5.0225 12.5667 5.98333 12.6383C6.275 12.66 6.54167 12.8133 6.70417 13.0558L9 16.5L11.2958 13.0558C11.3764 12.9361 11.4831 12.8362 11.608 12.7639C11.733 12.6915 11.8727 12.6486 12.0167 12.6383C12.971 12.5671 13.9224 12.4617 14.8692 12.3225C16.1892 12.1283 17.125 10.9675 17.125 9.6325V4.6175C17.125 3.2825 16.1892 2.12167 14.8692 1.9275C12.9258 1.64226 10.9642 1.49938 9 1.5C7.00667 1.5 5.04667 1.64584 3.13083 1.9275C1.81083 2.12167 0.875 3.28334 0.875 4.6175V9.6325V9.63334Z"
    //                 strokeWidth="1.26316"
    //                 strokeLinecap="round"
    //                 strokeLinejoin="round"
    //             />
    //         </svg>
    //     ),
    // },
    {
        id: 1,
        name: "notification",
        path: "/page/notification",
        icon: (
            <svg
                width="26"
                height="26"
                className="stroke-current"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.5007 13.1667H14.6673L13.4965 11.9959C13.179 11.6784 13.0007 11.2477 13.0007 10.7987V8.16667C13.0007 5.98964 11.6093 4.13757 9.66732 3.45118V3.16667C9.66732 2.24619 8.92113 1.5 8.00065 1.5C7.08018 1.5 6.33398 2.24619 6.33398 3.16667V3.45118C4.392 4.13757 3.00065 5.98964 3.00065 8.16667V10.7987C3.00065 11.2477 2.82227 11.6784 2.50476 11.9959L1.33398 13.1667H5.50065M10.5007 13.1667V14C10.5007 15.3807 9.38136 16.5 8.00065 16.5C6.61994 16.5 5.50065 15.3807 5.50065 14V13.1667M10.5007 13.1667H5.50065"
                    strokeWidth="1.26316"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    {
        id: 2,
        name: "emails",
        path: "/page/inbox",
        icon: (
            <svg
                width="26"
                height="26"
                className="stroke-current"
                viewBox="0 0 18 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.5 3.6665L8.0755 8.05017C8.63533 8.42339 9.36467 8.42339 9.9245 8.05017L16.5 3.6665M3.16667 12.8332H14.8333C15.7538 12.8332 16.5 12.087 16.5 11.1665V2.83317C16.5 1.9127 15.7538 1.1665 14.8333 1.1665H3.16667C2.24619 1.1665 1.5 1.9127 1.5 2.83317V11.1665C1.5 12.087 2.24619 12.8332 3.16667 12.8332Z"
                    strokeWidth="1.26316"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
];

const Header = ({ sidebar, setSidebar }) => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const clientId = process.env.REACT_APP_GOOGLE_ID;
    const [open, setOpen] = useState(false);
    const [profileSidebar, setProfileSidebar] = useState(false);
    const [notifyModal, setNotifyModal] = useState(false);
    const navigate = useNavigate();
    const [show, setShow] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setShow((prevShow) => !prevShow);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setShow(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setShow(false);
        }
    }

    // return focus to the button when we transitioned from !show -> show
    const prevShow = React.useRef(show);
    React.useEffect(() => {
        if (prevShow.current === true && show === false) {
            anchorRef.current.focus();
        }

        prevShow.current = show;
    }, [show]);

    const { userProfile, livestream, notifications, isLiveStreaming } =
        useSelector((state) => {
            return {
                userProfile: getUserProfile(state),
                livestream: state.SocialReducer.createLiveStreamResponse,
                notifications: getNotificationList(state),
                isLiveStreaming: state.SocialReducer.isLiveStreaming,
            };
        });

    useEffect(() => {
        dispatch(getDeliveryAddressRequest());
    }, []);

    useEffect(() => {
        if (!notifications || !notifications.data) {
            dispatch(fetchNotificationRequest());
        }
    }, [notifications]);

    const signOut = () => {
        
        clearToken();
        console.log("Logged out Success");
        document.location.href = "/login";
    };

    const handleLogout = () => {
        if (livestream._id && livestream.streamingStatus === "Streaming") {
            Swal.fire({
                title: "Confirm log out?",
                text:
                    livestream.owner._id === userProfile._id
                        ? "Logging out will end the livestream. "
                        : "Logging out will leave the livestream. ",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "green",
                cancelButtonText: "Cancel",
                confirmButtonText: "Proceed",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    if (livestream.owner._id === userProfile._id) {
                        socket.emit("endLive", {
                            room: livestream._id,
                            type: "host",
                            infoUser: userProfile,
                        });
                    } else {
                        socket.emit("leftLive", {
                            room: livestream._id,
                            type: "viewers",
                            infoUser: userProfile,
                        });
                    }

                    if (navigator.mediaDevices.getUserMedia) {
                        navigator.mediaDevices
                            .getUserMedia({ video: true })
                            .then(function (stream) {
                                var video = document.querySelector("video");
                                video.srcObject = stream;
                            })
                            .catch(function () {
                                console.log("Something went wrong!");
                            });
                    }
                }
                signOut();
            });
        } else {
            signOut();
        }
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // {/* Performs similarly to componentDidMount in classes */}
    useEffect(() => {
        window.addEventListener(
            "resize",
            () => {
                const ismobile = window.innerWidth < 768;
                if (ismobile !== isMobile) setIsMobile(ismobile);
            },
            false
        );
    }, [isMobile]);

    const chatRoomCnt =
        notifications.data &&
        notifications.data.filter(
            (x) => x.type === "chatRoom" && x.isRead === false
        ).length;
    const inboxCnt =
        notifications.data &&
        notifications.data.filter(
            (x) => x.type === "inbox" && x.isRead === false
        ).length;
    const notCount =
        notifications.data &&
        notifications.data.filter(
            (x) =>
                x.type !== "chatRoom" &&
                x.type !== "inbox" &&
                x.isRead === false
        ).length;

    const OnChat = () => {
        NotificationAPI.updateReadNotifications({
            type: "chatRoom",
        }).finally(() => dispatch(fetchNotificationRequest()));
    };

    return (
        <header className="relative">
            {isLiveStreaming &&
                location.pathname.indexOf("/page/livestream") === -1 &&
                location.pathname.indexOf("/page/preview") === -1 &&
                livestream.streamingStatus === "Streaming" &&
                livestream._id && <PIPComponent />}
            <div className="px-3 sm:px-4 py-2 md:py-5 h-16 md:h-[88px] mx-auto flex items-center justify-between border-b border-black-10 fixed w-full top-0 left-0 bg-white z-40">
                <div className="shrink-0 flex items-center">
                    <HiOutlineMenuAlt1
                        onClick={() => setSidebar(!sidebar)}
                        className={
                            "text-3xl sm:text-4xl mr-2.5 cursor-pointer lg:hidden"
                        }
                    />
                    <Link to="/" className=" ">
                        <img src={logo} className="w-24 sm:w-32 " alt="" />
                    </Link>
                </div>

                <div className="py-2.5 md:py-0 lg:ml-[165px] flex justify-between items-center w-full px-3 sm:px-4 md:px-0 fixed md:static bottom-0 left-0 bg-white bottom-nav-shadow md:shadow-none">
                    <div className="hidden md:block mx-auto lg:m-0">
                        <MobileNavSearch
                            setOpen={setOpen}
                            navigate={navigate}
                        />
                    </div>
                    <ul className="flex items-center w-full justify-between md:w-auto gap-x-4 sm:gap-x-6 px-2 md:px-0">
                        <li className="md:hidden text-black-50 hover:text-orange-color cursor-pointer">
                            <Link to="/">
                                <svg
                                    width="26"
                                    height="26"
                                    className="stroke-current"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1.5 9L3.16667 7.33333M3.16667 7.33333L9 1.5L14.8333 7.33333M3.16667 7.33333V15.6667C3.16667 16.1269 3.53976 16.5 4 16.5H6.5M14.8333 7.33333L16.5 9M14.8333 7.33333V15.6667C14.8333 16.1269 14.4602 16.5 14 16.5H11.5M6.5 16.5C6.96024 16.5 7.33333 16.1269 7.33333 15.6667V12.3333C7.33333 11.8731 7.70643 11.5 8.16667 11.5H9.83333C10.2936 11.5 10.6667 11.8731 10.6667 12.3333V15.6667C10.6667 16.1269 11.0398 16.5 11.5 16.5M6.5 16.5H11.5"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Link>
                        </li>
                        <li className="md:hidden">
                            <div
                                onClick={() => navigate("/page/search")}
                                className=" border border-transparent rounded-full p-2 text-black-50 hover:text-orange-color cursor-pointer"
                            >
                                <svg
                                    width="22"
                                    height="22"
                                    className=" fill-current"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                                    />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <div>
                                <Button
                                    ref={anchorRef}
                                    color="secondary"
                                    variant="contained"
                                    endIcon={!show ? <ChevronDownIcon /> : <ChevronUpIcon />}
                                    aria-controls={show ? 'menu-list-grow' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleToggle}
                                >
                                    Quick Start
                                </Button>
                                <Popper open={show} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <MenuList autoFocusItem={show} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                        <MenuItem onClick={(e) => {
                                                            handleClose(e);
                                                            navigate("/page/instant_video#Recording")
                                                        }}>
                                                            <Box width={"100%"} display={"flex"} alignItems="center" className="border-primary p-2">


                                                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M10.1522 12.9489C11.8133 12.9489 13.1598 11.6023 13.1598 9.94124C13.1598 8.28016 11.8133 6.93359 10.1522 6.93359C8.4911 6.93359 7.14453 8.28016 7.14453 9.94124C7.14453 11.6023 8.4911 12.9489 10.1522 12.9489Z" fill="#7900F8" />
                                                                    <path d="M7.33314 0.541016L5.61314 2.4208H2.63369C1.59981 2.4208 0.753906 3.2667 0.753906 4.30058V15.5793C0.753906 16.6131 1.59981 17.459 2.63369 17.459H17.6719C18.7058 17.459 19.5517 16.6131 19.5517 15.5793V4.30058C19.5517 3.2667 18.7058 2.4208 17.6719 2.4208H14.6925L12.9725 0.541016H7.33314ZM10.1528 14.6394C7.55872 14.6394 5.45336 12.534 5.45336 9.93992C5.45336 7.34582 7.55872 5.24047 10.1528 5.24047C12.7469 5.24047 14.8523 7.34582 14.8523 9.93992C14.8523 12.534 12.7469 14.6394 10.1528 14.6394Z" fill="#7900F8" />
                                                                </svg>


                                                                <span className="pl-2 text-medium">
                                                                    Use device camera
                                                                </span>
                                                            </Box>
                                                        </MenuItem>
                                                        <MenuItem onClick={(e) => {
                                                            handleClose(e);
                                                            navigate("/page/instant_video#ScreenSharing")
                                                        }}>
                                                            <Box width={"100%"} display={"flex"} alignItems="center" className="border-primary p-2" >

                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="12" cy="12" r="9.71721" stroke="#7900F8" stroke-width="0.565574" />
                                                                    <circle cx="12" cy="12" r="6" fill="#7900F8" />
                                                                </svg>

                                                                <span className="pl-2 text-medium">
                                                                    Screen recording
                                                                </span>
                                                            </Box>
                                                        </MenuItem>
                                                        <MenuItem onClick={(e) => {
                                                            handleClose(e);
                                                            navigate("/page/instant_video#Embed")
                                                        }}>
                                                            <Box width={"100%"} display={"flex"} alignItems="center" className="border-primary p-2">


                                                                <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M5.54708 0.688085C4.56101 0.856017 3.62661 1.24355 2.8214 1.81625C2.37358 2.13489 1.67601 2.83246 1.35737 3.28028C0.849265 3.99076 0.453116 4.90363 0.263654 5.79066C0.151699 6.31598 0.151699 7.81016 0.263654 8.33118C0.840653 11.0181 2.97641 13.0419 5.66334 13.4337C6.02934 13.4854 6.41688 13.4983 7.45031 13.4897L8.76794 13.4768L8.9574 13.3476C9.53871 12.9343 9.48704 12.0515 8.85836 11.7329C8.70765 11.6554 8.60431 11.6468 7.73451 11.6468C6.0724 11.6468 5.47818 11.5563 4.70311 11.1946C4.20361 10.9621 3.83761 10.7167 3.46299 10.3593C1.99465 8.95985 1.61142 6.80687 2.51137 5.01558C3.0367 3.97354 4.03568 3.09943 5.11217 2.73342C5.71931 2.53104 5.93892 2.5052 7.38572 2.47937L8.76794 2.45353L8.9574 2.32435C9.53871 1.91098 9.48704 1.02826 8.85836 0.709615C8.70335 0.627801 8.60862 0.623495 7.28238 0.627801C6.34799 0.632107 5.76237 0.649331 5.54708 0.688085Z" fill="#7900F8" />
                                                                    <path d="M13.5349 0.692146C12.8847 1.04524 12.8245 1.90212 13.4187 2.32411L13.6081 2.45329L15.0119 2.47912C16.4759 2.50926 16.6568 2.53079 17.2553 2.73317C18.3404 3.09918 19.3351 3.96899 19.8647 5.01534C20.9929 7.26305 20.0671 10.006 17.7979 11.1384C17.0013 11.5389 16.6266 11.6035 14.999 11.6336C13.8278 11.6551 13.6469 11.6681 13.5091 11.737C12.8847 12.0513 12.8374 12.934 13.4187 13.3474L13.6081 13.4766H15.1195C16.5233 13.4723 16.6654 13.468 17.0745 13.3775C19.6451 12.8177 21.544 10.9145 22.1081 8.33093C22.2244 7.80991 22.2244 6.32004 22.1124 5.79041C21.923 4.90338 21.5268 3.99052 21.0187 3.28003C20.7001 2.83221 20.0025 2.13465 19.5547 1.816C18.8614 1.32512 17.9701 0.928974 17.0874 0.726594C16.6051 0.618945 13.7287 0.588803 13.5349 0.692146Z" fill="#7900F8" />
                                                                    <path d="M8.02323 6.20801C7.37303 6.54818 7.31274 7.41368 7.90697 7.83566L8.09643 7.96484H11.1881H14.2798L14.4693 7.83566C15.0506 7.42229 14.9989 6.53957 14.3702 6.22093C14.2109 6.13911 14.1076 6.13481 11.1795 6.13481C8.5098 6.13911 8.13518 6.14773 8.02323 6.20801Z" fill="#7900F8" />
                                                                </svg>


                                                                <span className="pl-2 text-medium">
                                                                    Paste video URL
                                                                </span>
                                                            </Box>
                                                        </MenuItem>
                                                        <MenuItem onClick={(e) => {
                                                            handleClose(e);
                                                            navigate("/page/instant_video#Uploading")
                                                        }}>
                                                            <Box width={"100%"} display={"flex"} alignItems="center" className="border-primary p-2" >


                                                                <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M0.53533 0.896809L0.179688 1.25245V7.87476V14.4848L0.486276 14.8159L0.7806 15.1348H6.72841H12.664L12.4187 14.4235C12.0385 13.3443 12.1366 11.7991 12.6517 10.6831C13.6696 8.51246 16.0242 7.22479 18.2439 7.61722C18.6608 7.6908 19.1023 7.78891 19.2249 7.83797C19.4212 7.92381 19.4334 7.71533 19.4334 4.58813V1.25245L19.0778 0.896809L18.7221 0.541166H9.80656H0.890972L0.53533 0.896809ZM2.50976 2.13542V2.87124H1.77395H1.03813V2.22127C1.03813 1.85336 1.07493 1.52225 1.12398 1.48546C1.16077 1.4364 1.49188 1.39961 1.85979 1.39961H2.50976V2.13542ZM18.4278 1.54678C18.5137 1.63262 18.575 1.96374 18.575 2.28259V2.87124H17.8392H17.1034V2.13542V1.39961H17.692C18.0109 1.39961 18.342 1.46093 18.4278 1.54678ZM10.0641 4.84566C11.8791 5.99844 13.4366 7.02857 13.5224 7.13894C13.7922 7.49459 13.829 7.91155 13.645 8.31624C13.4979 8.62283 12.7498 9.15016 10.1254 10.818C6.48314 13.1358 6.36051 13.1849 5.67375 12.5717L5.26905 12.216V7.83797V3.45989L5.67375 3.10424C5.90675 2.89576 6.21334 2.7486 6.40956 2.7486C6.64257 2.7486 7.8076 3.41083 10.0641 4.84566ZM2.50976 4.40418V5.07867H1.77395H1.03813V4.40418V3.72968H1.77395H2.50976V4.40418ZM18.575 4.40418V5.07867H17.8392H17.1034V4.40418V3.72968H17.8392H18.575V4.40418ZM2.50976 6.67293V7.40874H1.77395H1.03813V6.67293V5.93712H1.77395H2.50976V6.67293ZM18.575 6.67293V7.40874H17.8392H17.1034V6.67293V5.93712H17.8392H18.575V6.67293ZM2.50976 9.003V9.73881H1.77395H1.03813V9.003V8.26719H1.77395H2.50976V9.003ZM2.50976 11.3331V12.0689H1.77395H1.03813V11.3331V10.5973H1.77395H2.50976V11.3331ZM2.50976 13.6018V14.2886L1.81074 14.2518L1.09945 14.215L1.06266 13.565L1.02587 12.9273H1.76168H2.50976V13.6018Z" fill="#7900F8" />
                                                                    <path d="M16.3662 8.27897C15.0049 8.54877 13.8154 9.49306 13.2022 10.8175C12.9079 11.4307 12.8711 11.6637 12.8711 12.8042C12.8711 13.9938 12.8956 14.1532 13.2635 14.9135C14.0239 16.5201 15.2625 17.3295 17.1143 17.4398C17.985 17.4889 18.3406 17.4521 19.0764 17.2313C19.849 16.9861 20.0698 16.8512 20.7198 16.2012C21.7499 15.1711 22.0565 14.3985 22.0565 12.8042C22.0565 11.7863 22.0197 11.5411 21.7254 10.9034C21.2593 9.91002 20.8792 9.43174 20.1311 8.9412C19.1132 8.2667 17.6907 8.02143 16.3662 8.27897ZM18.6104 10.842C19.1255 11.5779 19.5915 12.2646 19.6406 12.375C19.7387 12.6448 19.4811 12.8042 18.9783 12.8042H18.5736V14.3739C18.5736 15.4286 18.5246 15.9927 18.4265 16.0908C18.2793 16.238 16.9058 16.2993 16.5624 16.1644C16.3907 16.1031 16.3662 15.8333 16.3662 14.4598V12.8165L15.8511 12.7797C15.471 12.7552 15.3115 12.6816 15.287 12.5344C15.238 12.2524 17.2124 9.49306 17.4577 9.49306C17.568 9.49306 18.0831 10.1062 18.6104 10.842Z" fill="#7900F8" />
                                                                </svg>


                                                                <span className="pl-2 text-medium">
                                                                    Upload video File
                                                                </span>
                                                            </Box>
                                                        </MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </div>
                        </li>

                        {routes.map((route) => {
                            if (!isMobile && route.name === "notification") {
                                route.path = "#";
                            } else if (
                                isMobile &&
                                route.name === "notification"
                            ) {
                                route.path = "/page/notification";
                            }
                            return (
                                <li
                                    key={route.id}
                                    onClick={() => {
                                        route.name === "notification" &&
                                            setNotifyModal(true);
                                        if (chatRoomCnt > 0) {
                                            route.name === "chat" && OnChat();
                                        }
                                    }}
                                    className={`relative cursor-pointer`}
                                >
                                    <Link
                                        to={route.path}
                                        className={`focus:text-orange-color`}
                                    >
                                        <div
                                            className={` text-black-50 hover:text-orange-color`}
                                        >
                                            {route.icon}
                                        </div>
                                        {((notCount > 0 &&
                                            route.name === "notification") ||
                                            (inboxCnt > 0 &&
                                                route.name === "emails") ||
                                            (chatRoomCnt > 0 &&
                                                route.name === "chat")) && (
                                                <div
                                                    className={` w-2 aspect-square bg-orange-color rounded-full absolute -top-0.5 -right-0.5`}
                                                ></div>
                                            )}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                {/* Profile top img  */}
                <div className={` shrink-0`}>
                    <ul className="flex gap-x-4 items-center ml-6">
                        <li className="relative cursor-pointer">
                            <Link
                                to="#"
                                onClick={() =>
                                    setProfileSidebar(!profileSidebar)
                                }
                                className="flex items-center"
                            >
                                <img
                                    src={getImage(
                                        userProfile.avatar.attachments
                                    )}
                                    className={` w-11 aspect-square rounded-full shrink-0`}
                                    alt=""
                                />
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Profile Sidebar  */}
            <div className="">
                <div
                    onClick={() => setProfileSidebar(null)}
                    className={`${!profileSidebar && "hidden"
                        } duration-300 ease-linear fixed top-0 right-0 left-0 bottom-0 z-50 bg-black-30`}
                ></div>
                <div
                    className={`${profileSidebar
                        ? "translate-x-0 ease-in"
                        : "translate-x-full ease-out"
                        } duration-300 w-[300px] bg-white fixed top-0  right-0 bottom-0 px-4 overflow-y-auto overflow-hidden z-[100]`}
                >
                    <div className="h-full flex flex-col justify-between">
                        <div className="">
                            <div className="mb-[22px]">
                                <div className=" flex flex-col items-center mt-6 mb-5">
                                    <img
                                        src={getImage(
                                            userProfile.avatar.attachments
                                        )}
                                        className="w-[108px] h-[108px] rounded-full mb-1.5"
                                        alt=""
                                    />
                                    <div className="text-center relative">
                                        {userProfile.role === "Pro" && (
                                            <button className="absolute p-2 py-1 text-sm font-bold text-white bg-orange-color block rounded-lg right-[-50px] top-[-5px]">
                                                Pro
                                            </button>
                                        )}

                                        <h5 className="text-sm text-ebony-color font-medium mb-px">
                                            {userProfile.fullName}
                                        </h5>
                                        <p className="text-sm text-black-70">
                                            @{userProfile.userName}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex justify-between px-4 mb-[22px]">
                                    <div
                                        className="text-center cursor-pointer"
                                        onClick={() => {
                                            setProfileSidebar(null);
                                            history(
                                                "/page/profile/list#follower"
                                            );
                                        }}
                                    >
                                        <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                            {userProfile.countFollower}
                                        </span>
                                        <p className="text-sm text-black-50">
                                            Followers
                                        </p>
                                    </div>
                                    <div
                                        className="text-center cursor-pointer"
                                        onClick={() => {
                                            setProfileSidebar(null);
                                            history(
                                                "/page/profile/list#following"
                                            );
                                        }}
                                    >
                                        <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                            {userProfile.countFollowing}
                                        </span>
                                        <p className="text-sm text-black-50">
                                            Following
                                        </p>
                                    </div>
                                    <div
                                        className="text-center cursor-pointer"
                                        onClick={() => {
                                            setProfileSidebar(null);
                                            history(
                                                "/page/profile/list#subscriber"
                                            );
                                        }}
                                    >
                                        <span className="text-lg mb-0.5 font-bold text-ebony-color">
                                            {userProfile.countSubscriber}
                                        </span>
                                        <p className="text-sm text-black-50">
                                            Subscribers
                                        </p>
                                    </div>
                                </div>
                                <div
                                    onClick={() =>
                                        history("/page/start-new-video")
                                    }
                                    className=""
                                >
                                    <button className="text-sm font-bold text-white py-2.5 bg-orange-color w-full block rounded-lg">
                                        Start new video
                                    </button>
                                </div>
                            </div>

                            {/* Profile nav  */}
                            <ul className="flex flex-col gap-y-1">
                                <li>
                                    <NavLink
                                        onClick={() => setProfileSidebar(null)}
                                        to="/page/profile"
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="16"
                                                height="16"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M1.75 15.5C1.75 15.5 0.5 15.5 0.5 14.25C0.5 13 1.75 9.25 8 9.25C14.25 9.25 15.5 13 15.5 14.25C15.5 15.5 14.25 15.5 14.25 15.5H1.75ZM8 8C8.99456 8 9.94839 7.60491 10.6517 6.90165C11.3549 6.19839 11.75 5.24456 11.75 4.25C11.75 3.25544 11.3549 2.30161 10.6517 1.59835C9.94839 0.895088 8.99456 0.5 8 0.5C7.00544 0.5 6.05161 0.895088 5.34835 1.59835C4.64509 2.30161 4.25 3.25544 4.25 4.25C4.25 5.24456 4.64509 6.19839 5.34835 6.90165C6.05161 7.60491 7.00544 8 8 8Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            View profile
                                        </span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        onClick={() => setProfileSidebar(null)}
                                        to="/page/account"
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="17"
                                                height="19"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                viewBox="0 0 17 19"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M2.33366 8.3335V14.1668H4.83366V8.3335H2.33366ZM7.33366 8.3335V14.1668H9.83366V8.3335H7.33366ZM0.666992 18.3335H16.5003V15.8335H0.666992V18.3335ZM12.3337 8.3335V14.1668H14.8337V8.3335H12.3337ZM8.58366 0.833496L0.666992 5.00016V6.66683H16.5003V5.00016L8.58366 0.833496Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            Account & preferences
                                        </span>
                                    </NavLink>
                                </li>
                                {/* <li>
                                    <NavLink
                                        onClick={() => setProfileSidebar(null)}
                                        to="/vf"
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color profile-nav"
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="16"
                                                height="16"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M8 15.4998C5.90278 15.4998 4.12833 14.774 2.67667 13.3223C1.22556 11.8712 0.5 10.0971 0.5 7.99984C0.5 6.08317 1.125 4.41984 2.375 3.00984C3.625 1.60039 5.22222 0.777615 7.16667 0.541504C7.51389 0.499837 7.78472 0.624837 7.97917 0.916504C8.17361 1.20817 8.16667 1.51373 7.95833 1.83317C7.72222 2.19428 7.545 2.57623 7.42667 2.979C7.30889 3.38178 7.25 3.80539 7.25 4.24984C7.25 5.49984 7.6875 6.56234 8.5625 7.43734C9.4375 8.31234 10.5 8.74984 11.75 8.74984C12.1806 8.74984 12.6078 8.68734 13.0317 8.56234C13.455 8.43734 13.8333 8.26373 14.1667 8.0415C14.4583 7.84706 14.7569 7.8365 15.0625 8.00984C15.3681 8.18373 15.5 8.45817 15.4583 8.83317C15.2639 10.7498 14.4481 12.3401 13.0108 13.604C11.5731 14.8679 9.90278 15.4998 8 15.4998Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            Dark mode
                                        </span>
                                    </NavLink>
                                </li> */}
                                <li>
                                    <NavLink
                                        onClick={() => {
                                            setProfileSidebar(null);
                                            handleLogout();
                                        }}
                                        className="flex items-center py-2 px-[9px] hover:bg-purple-color/5 rounded-10 text-black-50 hover:text-ebony-color "
                                    >
                                        <div className="mr-4 p-2 bg-black-5 rounded-md">
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                className="text-black-50 hover:text-purple-color fill-current profile-nav-icon"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M15.3203 8.44531L12.0391 11.7266C11.9191 11.8412 11.7597 11.9055 11.5938 11.9062C11.5133 11.9065 11.4336 11.8905 11.3594 11.8594C11.2442 11.8128 11.1455 11.7329 11.0759 11.6299C11.0063 11.5269 10.969 11.4055 10.9688 11.2812V8.625H6.125C5.95924 8.625 5.80027 8.55915 5.68306 8.44194C5.56585 8.32473 5.5 8.16576 5.5 8C5.5 7.83424 5.56585 7.67527 5.68306 7.55806C5.80027 7.44085 5.95924 7.375 6.125 7.375H10.9688V4.71875C10.969 4.59447 11.0063 4.47308 11.0759 4.37011C11.1455 4.26713 11.2442 4.18723 11.3594 4.14062C11.4735 4.0953 11.5982 4.08372 11.7187 4.10727C11.8392 4.13082 11.9504 4.18849 12.0391 4.27344L15.3203 7.55469C15.4377 7.67318 15.5035 7.83322 15.5035 8C15.5035 8.16678 15.4377 8.32682 15.3203 8.44531ZM6.125 14.25H1.75V1.75H6.125C6.29076 1.75 6.44973 1.68415 6.56694 1.56694C6.68415 1.44973 6.75 1.29076 6.75 1.125C6.75 0.95924 6.68415 0.800269 6.56694 0.683058C6.44973 0.565848 6.29076 0.5 6.125 0.5H1.75C1.41848 0.5 1.10054 0.631696 0.866116 0.866116C0.631696 1.10054 0.5 1.41848 0.5 1.75V14.25C0.5 14.5815 0.631696 14.8995 0.866116 15.1339C1.10054 15.3683 1.41848 15.5 1.75 15.5H6.125C6.29076 15.5 6.44973 15.4342 6.56694 15.3169C6.68415 15.1997 6.75 15.0408 6.75 14.875C6.75 14.7092 6.68415 14.5503 6.56694 14.4331C6.44973 14.3158 6.29076 14.25 6.125 14.25Z" />
                                            </svg>
                                        </div>
                                        <span className="capitalize text-sm font-medium">
                                            Sign out
                                        </span>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                        <div className="pt-1 pb-4 border-t border-black-10 text-center mt-28">
                            <p className="text-sm font-medium text-black-30">
                                &copy; 2022 Ulalive Inc
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="hidden md:block">
                <NotificationsModal
                    show={notifyModal}
                    onClose={() => setNotifyModal(!notifyModal)}
                >
                    <NotificationComponent
                        onClose={() => setNotifyModal(!notifyModal)}
                    />
                </NotificationsModal>
            </div>
        </header>
    );
};

export const MobileNavSearch = ({ navigate, setOpen }) => {
    const filterOptions = createFilterOptions({
        matchFrom: "any",
        stringify: (option) => option.name,
    });

    const dispatch = useDispatch();
    const history = useNavigate();
    const [autoItem, setAutoItem] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [optionValue, setOptionValue] = useState({});
    const [inputValue, setinputValue] = useState("");
    const [placeholder, setPlaceholder] = useState(
        "Search user, video or product"
    );

    const {
        allProducts,
        userProfile,
        justLiveStreams,
        allUsers,
        recentLiveStreams,
    } = useSelector((state) => {
        return {
            allUsers: getSearchedUsers(state),
            allProducts: getProductsList(state),
            recentLiveStreams: getRecentLiveStreams(state),
            justLiveStreams: getFollowingStreams(state),
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        dispatch(searchUserRequest());
        dispatch(getProductsRequest());
        dispatch(getRecentStreamRequest());
        dispatch(getJustStreamRequest());
        setTimeout(async () => {
            const close = await document.getElementsByClassName(
                "MuiAutocomplete-clearIndicator"
            )[0];
            close.addEventListener("click", () => {
                setinputValue("");
                setAutoItem(autoItem + 1);
            });
        }, 100);
    }, []);

    let streams = _.uniq(recentLiveStreams.concat(justLiveStreams), "_id");
    let items = streams.map((x) => {
        return {
            id: x._id,
            name: x.title,
            image: getImage(x.attachments, true),
            title: x.streamingStatus,
            type: "livestream",
            video: x.s3Url,
        };
    });

    if (allUsers) {
        items = items.concat(
            allUsers
                .filter((x) => x._id !== userProfile._id)
                .map((x) => {
                    return {
                        id: x._id,
                        name: x.fullName,
                        image: getImage(x.attachments),
                        title: x.account.userName,
                        type: "user",
                        isFollow: x.isFollow,
                    };
                })
        );
    }

    if (allProducts) {
        items = items.concat(
            allProducts
                .filter((x) => x.user !== userProfile._id)
                .map((x) => {
                    return {
                        id: x._id,
                        name: x.name,
                        image: getImage(x.attachments, "product"),
                        title: x.currency + " " + x.price,
                        type: "product",
                        price: x.price,
                        user: x.user,
                    };
                })
        );
    }

    items = _.sortBy(items, "name");
    return (
        <div className="">
            {/* <div className="relative mx-auto w-full md:max-w-[294px] bg-white rounded-full">
                <input
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            if (searchText.length > 2) {
                                navigate("/page/search", {
                                    state: { searchText: searchText },
                                });
                            }
                        }
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    type="search"
                    className="peer duration-300 ease-linear cursor-pointer relative z-[1] w-full h-11 md:w-[320px] rounded-full lg:valid:w-[500px] border border-black-10 bg-transparent pl-11 md:pl-12 outline-none focus:cursor-text focus:border-orange-color focus:pl-11 focus:pr-4 placeholder:hidden"
                    placeholder="Search user, product, tags and live"
                    id="search-input"
                    required
                />

                <svg
                    width="16"
                    height="16"
                    className="absolute inset-y-0 my-auto h-8 w-12 px-3 sm:px-3.5"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                        fill="black"
                        fillOpacity="0.5"
                    />
                </svg>
            </div> */}
            <Autocomplete
                onHighlightChange={(e, op, r) => {
                    if (op && op.type) {
                        setOptionValue(op);
                    }
                }}
                key={autoItem}
                open={inputValue.length > 2}
                id="filter-demo"
                forcePopupIcon={true}
                noOptionsText="No results found"
                onInputChange={(e) => {
                    if (e.target.value) {
                        if (optionValue.type) {
                            setOptionValue({});
                        }
                        setinputValue(e.target.value);
                    }

                    if (e.target.value && e.target.value.length === 0) {
                        setAutoItem(autoItem + 1);
                    }
                }}
                autoHighlight
                freeSolo
                popupIcon={<span />}
                renderOption={(option) => (
                    <List
                        id={option.id}
                        dense
                        classes={{
                            root: "p-0 m-0 w-full",
                        }}
                        disablePadding
                        onFocus={() => {
                            console.log("Hi");
                        }}
                        onClick={() => {
                            setTimeout(() => {
                                setAutoItem(autoItem + 1);
                            }, 1000);

                            setinputValue("");

                            if (option.type === "user") {
                                dispatch(
                                    fetchOtherUserProfileRequest(
                                        option.id,
                                        history
                                    )
                                );
                            } else if (option.type === "livestream") {
                                dispatch(
                                    fetchLiveStreamByIdRequest({
                                        id: option.id,
                                        history: history,
                                    })
                                );
                            } else if (option.type === "product") {
                                let exist = _.find(
                                    allProducts,
                                    (x) => x._id === option.id
                                );
                                if (exist) {
                                    exist = _.find(
                                        allUsers,
                                        (x) => x._id === exist.user
                                    );
                                    if (exist) {
                                        dispatch(
                                            fetchOtherUserProfileRequest(
                                                exist._id,
                                                null
                                            )
                                        );
                                        setTimeout(() => {
                                            history(
                                                "/" +
                                                exist.account.userName +
                                                "/profile/shop"
                                            );
                                        }, 2000);
                                    }
                                }
                            }
                        }}
                    >
                        <ListItem disableGutters>
                            <ListItemAvatar>
                                {option.video ? (
                                    <video
                                        src={option?.video}
                                        muted
                                        playsInline
                                        height={48}
                                        width={48}
                                    />
                                ) : (
                                    <Avatar
                                        className="search-img"
                                        variant={
                                            option.type === "product"
                                                ? "square"
                                                : option.type === "livestream"
                                                    ? "rounded"
                                                    : "circular"
                                        }
                                        src={option.image}
                                    />
                                )}
                            </ListItemAvatar>
                            <ListItemText
                                primary={option.name}
                                classes={{
                                    primary: "overflow-text max-w-[200px]",
                                }}
                                secondary={option.title}
                            />
                            <ListItemSecondaryAction>
                                {option.type === "product" ? (
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            SocialAPI.GetDummyLivestream(
                                                option.user
                                            ).then((x) => {
                                                dispatch(
                                                    addCartRequest({
                                                        product: option.id,
                                                        quantity: 1,
                                                        livestream: x.data._id,
                                                    })
                                                );
                                            });
                                        }}
                                        variant="contained"
                                        size="small"
                                        color="secondary"
                                    >
                                        Shop
                                    </Button>
                                ) : option.type === "livestream" ? (
                                    <Button
                                        variant="contained"
                                        startIcon={
                                            option.title === "Streaming" ? (
                                                <AddCircleRounded />
                                            ) : (
                                                <></>
                                            )
                                        }
                                        size="small"
                                        color={
                                            option.title === "Streaming"
                                                ? "secondary"
                                                : "primary"
                                        }
                                        className="bg-danger text-light"
                                    >
                                        {option.title === "Streaming"
                                            ? "Join"
                                            : "Watch"}
                                    </Button>
                                ) : option.type === "user" ? (
                                    <Button
                                        onClick={(e) => {
                                            if (!option.isFollow) {
                                                e.stopPropagation();
                                                dispatch(
                                                    followUserRequest({
                                                        following: option.id,
                                                    })
                                                );
                                            }
                                        }}
                                        variant="contained"
                                        startIcon={
                                            !option.isFollow ? (
                                                <AddCircleRounded />
                                            ) : (
                                                <></>
                                            )
                                        }
                                        size="small"
                                        color={
                                            !option.isFollow
                                                ? "secondary"
                                                : "inherit"
                                        }
                                        className="bg-danger text-light"
                                    >
                                        {option.isFollow
                                            ? "Following"
                                            : "Follow"}
                                    </Button>
                                ) : (
                                    <></>
                                )}
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                )}
                options={items}
                getOptionLabel={(option) => option.name}
                filterOptions={filterOptions}
                style={{ width: "30vw", borderRadius: 25 }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        if (e.target.value.length > 2) {
                            setAutoItem(autoItem + 1);
                            e.target.placeholder = "Search...";
                            setinputValue("");
                            setOptionValue({});
                            navigate("/page/search", {
                                state: { searchText: e.target.value },
                            });
                        }
                    }
                }}
                renderInput={(params) => (
                    <>
                        <TextField
                            {...params}
                            margin="dense"
                            onChange={(e) => {
                                console.log(e.target.value);
                            }}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {" "}
                                        <SearchIcon className="text-black-50" />
                                    </InputAdornment>
                                ),
                                disableUnderline: true,
                            }}
                            onFocus={(e) => (e.target.placeholder = "")}
                            onBlur={(e) => {
                                e.target.placeholder = "Search...";
                                setinputValue("");
                                setOptionValue({});
                                setAutoItem(autoItem + 1);
                            }}
                            placeholder={placeholder}
                            variant="outlined"
                        />
                    </>
                )}
            />
        </div>
    );
};

export default Header;
